/**
 * Created by Jie Gao on 2019-05-20.
 */

import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ReelSymbolName} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolName";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {GGParsedGameData} from "../../server/data/GGParsedGameData";
import {TimelineLite} from "gsap";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {GGSoundConfig} from "../../GGSoundConfig";
import {GGGameModuleConfig} from "../../GGGameModuleConfig";
import {GGReelSymbolH} from "../../symbols/GGReelSymbolH";
import {GGReelView} from "../../reel/GGReelView";
import {GGGameConfig} from "../../GGGameConfig";

export class ScatterWin extends WinPresentationController {

    private _fsTriggered:boolean;
    private _timeline:TimelineLite | null;
    private _reels:string[][];

    constructor(indexes:[number, number]) {
        super(indexes, {name : "ScatterWin", skippable : false});
    }

    protected parseFeatureGameData(data:GGParsedGameData):void {
        this._fsTriggered = data.freespinTriggeredThisSpin;
        if(this._fsTriggered) {
            this._reels = data.reels;
        }
    }

    protected hasWin():boolean {
        // #576
        if (GGGameConfig.instance.FAULTY_WIN_CAP) {
            return false;
        }

        return this._fsTriggered;
    }

    protected startWinPresentation():void {
        this._timeline = new TimelineLite({paused:true});
        this._timeline.add(() => GGGameModuleConfig.soundPlayer.playSoundEffect(GGSoundConfig.SCATTER_WIN), 0);
        this._reels.forEach((reel:string[], reelId:number) => {
            reel.forEach((symbol:string, symId:number) => {
                if(symbol === ReelSymbolName.SCATTER) {
                    const scatter:StateReelSymbol = Reels.getSymbol(reelId, symId)!;
                    if(scatter == null) {
                        debugger;
                        throw new Error(`ScatterWin.startWinPresentation(), scatter at reelId ${reelId}, symbolId ${symId} is null!`);
                    }
                    //console.log("startWinPresentation scatter " + reelId);
                    (<GGReelView>Reels.getReel(reelId)!.view).addSymbolToWinContainer(scatter, true);
                    this._timeline!.add((<GGReelSymbolH>scatter).playTriggerAnimation(), 0);
                }
            });
        });
        //console.log("startWinPresentation scatter")
        this._timeline.add(() => this.finish());
        this._timeline.play();
    }

    protected stopWinPresentation(isAborted:boolean):void {
        if(isAborted) {
            if(this._timeline) {
                if(this._timeline.isActive()) {
                    this._timeline.pause();
                }
                this._timeline.kill();
            }
        }
        this._timeline = null;
    }
}